import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { includes } from 'lodash';
import * as moment from 'moment';

export const maxBytesError = 'maxBytes';

export function maxLengthInBytes(maxBytesCount: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const utf8BytesCount = control.value ? unescape(encodeURIComponent(control.value)).length : 0;
        return utf8BytesCount > maxBytesCount
            ? { [maxBytesError]: { requiredLength: maxBytesCount, actualLength: utf8BytesCount } }
            : null;
    };
}

export const forbiddenValueError = 'forbiddenValue';

export function forbidValues(forbiddenValues: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
        return includes(forbiddenValues, control.value)
            ? { [forbiddenValueError]: control.value }
            : null;
    };
}

export function notNullOrWhiteSpace(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: string = control.value;
        return (value == null || value.trim().length === 0)
            ? { 'required': true }
            : null;
    };
}

export const inValidDateError = 'inValidDate';

export function dateValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: string = control.value;
        const date = Date.parse(value);
        return isNaN(date)
            ? { [inValidDateError]: control.value }
            : null;
    }; 
}

export const futureDateError = 'futureDateError';

export function futureDateValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: string = control.value;
        const date = moment(value);
        const currentDate = moment();
        return date.isValid && date.isAfter(currentDate) ? { [futureDateError]: control.value } : null;
    };
}